export default "__VITE_ASSET__BpbyzELm__"